"use strict";
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/util/isScheduler.js